import styled from "styled-components";

export const DirectoryMenuContainer = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`;
